/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface CompleteCalendlyOAuth$Params {
  state?: string;
  code?: string;
  error?: string;
}

export function completeCalendlyOAuth(http: HttpClient, rootUrl: string, params?: CompleteCalendlyOAuth$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, completeCalendlyOAuth.PATH, 'get');
  if (params) {
    rb.query('state', params.state, {});
    rb.query('code', params.code, {});
    rb.query('error', params.error, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/html', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

completeCalendlyOAuth.PATH = '/v1/api/ui/public/calendly/oauth/callback';
